export interface Chapter {
  id: string;
  number: number;
  title: string;
  updateDate: string;
  views: number;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  cover: string;
  category: string;
  categorySlug: string;
  status: '连载中' | '已完结';
  description: string;
  shortDescription: string;
  updateTime: string;
  views: number;
  rating: number;
  isHot: boolean;
  isNew: boolean;
  chapters: Chapter[];
  tags: string[];
}

export const categories: { name: string; slug: string; icon: string }[] = [
  { name: '全部', slug: 'all', icon: 'ri-apps-line' },
  { name: '恋爱', slug: 'romance', icon: 'ri-heart-line' },
  { name: '动作', slug: 'action', icon: 'ri-flashlight-line' },
  { name: '奇幻', slug: 'fantasy', icon: 'ri-magic-line' },
  { name: '悬疑', slug: 'thriller', icon: 'ri-search-eye-line' },
  { name: '搞笑', slug: 'comedy', icon: 'ri-emotion-laugh-line' },
  { name: '耽美', slug: 'bl', icon: 'ri-star-line' },
  { name: '剧情', slug: 'drama', icon: 'ri-film-line' },
];

export const comics: Comic[] = [
  {
    id: 'comic-1',
    title: '再婚皇后',
    author: 'Alpha Tart',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20digital%20illustration%20of%20an%20elegant%20queen%20in%20royal%20palace%20attire%20with%20flowing%20golden%20hair%20and%20intricate%20crown%2C%20soft%20warm%20lighting%2C%20romantic%20fantasy%20art%20style%2C%20detailed%20jewelry%20and%20traditional%20Korean%20fabrics%2C%20emotional%20expression%2C%20clean%20cream%20background%2C%20professional%20manhwa%20cover%20quality&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    category: '恋爱',
    categorySlug: 'romance',
    status: '连载中',
    description: '在华丽宫廷的权力博弈中，娜维埃皇后被迫接受皇帝提出的离婚。但她并未就此沉沦，而是选择与邻国国王联姻，以自己的方式重新开始。一场关于尊严、复仇与真爱的华丽史诗就此展开，看她如何从被废皇后蜕变为令人敬畏的女王。这部作品以其精美的画风和扣人心弦的剧情，成为了韩国漫画中最受欢迎的古风恋爱作品之一。',
    shortDescription: '被废皇后娜维埃以联姻邻国国王的方式重新崛起，展开一场关于尊严与复仇的华丽史诗。',
    updateTime: '2026-08-04',
    views: 1285000,
    rating: 9.6,
    isHot: true,
    isNew: false,
    tags: ['古风', '宫斗', '逆袭', '恋爱'],
    chapters: [
      { id: 'ch-1-1', number: 1, title: '帝国的皇后', updateDate: '2025-01-15', views: 85000 },
      { id: 'ch-1-2', number: 2, title: '离婚宣言', updateDate: '2025-01-22', views: 82000 },
      { id: 'ch-1-3', number: 3, title: '新的选择', updateDate: '2025-01-29', views: 78000 },
    ],
  },
  {
    id: 'comic-2',
    title: '我独自升级',
    author: 'Chugong / DUBU',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20digital%20art%20of%20a%20powerful%20male%20hunter%20in%20dark%20combat%20armor%20with%20glowing%20blue%20energy%20surrounding%20him%2C%20standing%20in%20front%20of%20a%20dungeon%20portal%2C%20dramatic%20lighting%20with%20shadows%2C%20action%20fantasy%20genre%2C%20clean%20dark%20gradient%20background%2C%20professional%20manhwa%20cover%20quality&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    category: '动作',
    categorySlug: 'action',
    status: '已完结',
    description: '十多年前，世界各地突然出现了连接异次元的"传送门"，而人类中也觉醒了一群被称为"猎人"的超能力者。成振宇是E级猎人中的最弱者，在一次几乎团灭的双重地下城探险中，他意外获得了可以无限升级的独特能力。从最弱到最强，他将一步步揭开隐藏在传送门背后的惊天秘密。',
    shortDescription: '最弱E级猎人成振宇获得无限升级能力，从最弱到最强的逆袭之路。',
    updateTime: '2026-08-03',
    views: 3250000,
    rating: 9.8,
    isHot: true,
    isNew: false,
    tags: ['战斗', '升级', '爽文', '热血'],
    chapters: [
      { id: 'ch-2-1', number: 1, title: '最弱的猎人', updateDate: '2022-03-04', views: 150000 },
      { id: 'ch-2-2', number: 2, title: '双重地下城', updateDate: '2022-03-11', views: 148000 },
    ],
  },
  {
    id: 'comic-3',
    title: '某天成为公主',
    author: 'Plutus / Spoon',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20illustration%20of%20a%20beautiful%20young%20princess%20with%20long%20blonde%20hair%20and%20sparkling%20blue%20eyes%20wearing%20an%20ornate%20pink%20ballgown%20in%20a%20royal%20garden%20setting%2C%20soft%20pastel%20color%20palette%2C%20dreamy%20fantasy%20atmosphere%2C%20shojo%20manga%20style%2C%20clean%20light%20cream%20background%2C%20professional%20manhwa%20cover&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    category: '奇幻',
    categorySlug: 'fantasy',
    status: '已完结',
    description: '一个普通的现代女孩醒来后发现自己穿越成了一本小说中的公主——而且是一个注定要被亲生父亲处死的悲剧公主。为了改变自己的命运，她决定用尽一切方法赢得父皇的宠爱。然而随着时间推移，她发现这个世界远比小说中描绘的更加复杂和危险。',
    shortDescription: '穿越成悲剧公主的女孩为了改变命运，用尽方法赢得冷酷父皇的宠爱。',
    updateTime: '2026-08-02',
    views: 2100000,
    rating: 9.5,
    isHot: true,
    isNew: false,
    tags: ['穿越', '奇幻', '亲情', '治愈'],
    chapters: [
      { id: 'ch-3-1', number: 1, title: '醒来就是公主', updateDate: '2021-06-10', views: 120000 },
    ],
  },
  {
    id: 'comic-4',
    title: '全知读者视角',
    author: 'sing N song / Sleepy-C',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20digital%20art%20of%20a%20serious%20male%20protagonist%20holding%20a%20glowing%20book%20with%20mysterious%20symbols%2C%20surrounded%20by%20floating%20text%20fragments%20and%20apocalyptic%20cityscape%20background%2C%20dramatic%20lighting%2C%20dark%20fantasy%20genre%2C%20clean%20dark%20gradient%20background%2C%20professional%20manhwa%20cover&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    category: '动作',
    categorySlug: 'action',
    status: '连载中',
    description: '金独子是唯一一个读完了长达3149章的网络小说《在灭亡的世界中生存的三种方法》的读者。当小说中的末日场景在现实中成真时，他凭借对剧情的了解成为了这个世界唯一知道故事走向的人。在熟悉又陌生的末日世界中，他将如何利用自己的知识生存下去？',
    shortDescription: '当网络小说中的末日降临现实，唯一读完的读者成为了知道一切的人。',
    updateTime: '2026-08-04',
    views: 2890000,
    rating: 9.7,
    isHot: true,
    isNew: false,
    tags: ['末世', '系统', '生存', '智斗'],
    chapters: [
      { id: 'ch-4-1', number: 1, title: '最后的读者', updateDate: '2023-02-15', views: 200000 },
    ],
  },
  {
    id: 'comic-5',
    title: '她的私生活',
    author: '金成妍',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20romantic%20illustration%20of%20a%20professional%20woman%20in%20elegant%20office%20attire%20standing%20next%20to%20a%20handsome%20man%20in%20a%20gallery%20setting%2C%20soft%20romantic%20lighting%2C%20modern%20art%20museum%20interior%20background%2C%20warm%20amber%20tones%2C%20adult%20romance%20genre%2C%20clean%20cream%20background%2C%20professional%20manhwa%20cover&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    category: '恋爱',
    categorySlug: 'romance',
    status: '连载中',
    description: '美术馆首席策展人成德美，在职场上是完美干练的专业人士。但她有一个不为人知的秘密——她是一个狂热的偶像粉丝站站长。当新任馆长莱恩·戈尔德发现她的秘密后，两人之间展开了一段啼笑皆非又甜蜜浪漫的故事。',
    shortDescription: '美术馆策展人兼秘密粉丝站站长的双重生活，与新任馆长的浪漫邂逅。',
    updateTime: '2026-08-03',
    views: 1560000,
    rating: 9.3,
    isHot: true,
    isNew: false,
    tags: ['现代', '职场', '恋爱', '喜剧'],
    chapters: [
      { id: 'ch-5-1', number: 1, title: '完美的策展人', updateDate: '2023-08-20', views: 95000 },
    ],
  },
  {
    id: 'comic-6',
    title: '恶魔的契约',
    author: 'Jooah Kim',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20dark%20fantasy%20illustration%20of%20a%20mysterious%20man%20with%20red%20eyes%20and%20dark%20hair%20in%20elegant%20black%20suit%20making%20a%20contract%20gesture%20with%20glowing%20red%20symbols%2C%20gothic%20mansion%20background%2C%20dramatic%20shadow%20and%20light%20contrast%2C%20supernatural%20romance%20genre%2C%20clean%20dark%20background%2C%20professional%20manhwa%20cover&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    category: '悬疑',
    categorySlug: 'thriller',
    status: '连载中',
    description: '为了拯救病危的妹妹，林素熙与一个神秘的恶魔签订了契约。作为交换，她必须完成恶魔交付的七个任务。每一个任务都让她越陷越深，而恶魔的真实身份和目的也渐渐浮出水面。当她发现真相的那一刻，一切都已经太迟了。',
    shortDescription: '为了拯救妹妹与恶魔签订契约的女子，在执行七个任务中逐渐发现惊人真相。',
    updateTime: '2026-08-04',
    views: 980000,
    rating: 9.1,
    isHot: false,
    isNew: true,
    tags: ['悬疑', '超自然', '契约', '暗黑'],
    chapters: [
      { id: 'ch-6-1', number: 1, title: '绝望的选择', updateDate: '2025-11-01', views: 65000 },
    ],
  },
  {
    id: 'comic-7',
    title: '社内相亲',
    author: '海华 / NARAK',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20romantic%20comedy%20illustration%20of%20a%20young%20woman%20in%20colorful%20casual%20outfit%20looking%20shocked%20while%20a%20handsome%20man%20in%20business%20suit%20smiles%20at%20her%20across%20a%20restaurant%20table%2C%20bright%20warm%20lighting%2C%20modern%20cafe%20setting%2C%20fun%20lighthearted%20mood%2C%20clean%20soft%20background%2C%20professional%20manhwa%20cover&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    category: '搞笑',
    categorySlug: 'comedy',
    status: '已完结',
    description: '申夏莉代替闺蜜去参加了一场相亲，本想故意搞砸，却意外发现对方竟然是自己的公司社长姜泰武。更糟糕的是，社长似乎对她产生了兴趣。一场由谎言开始的相亲，却引出了一段令人捧腹又心动的办公室恋情。',
    shortDescription: '替闺蜜相亲却遇到公司社长，一场由谎言开始的搞笑浪漫办公室恋情。',
    updateTime: '2026-08-02',
    views: 1750000,
    rating: 9.4,
    isHot: true,
    isNew: false,
    tags: ['搞笑', '职场', '恋爱', '喜剧'],
    chapters: [
      { id: 'ch-7-1', number: 1, title: '替身相亲', updateDate: '2022-09-01', views: 110000 },
    ],
  },
  {
    id: 'comic-8',
    title: '深渊的天空',
    author: 'Youn In-Wan / Kim Sun-Hee',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20dark%20thriller%20illustration%20of%20a%20group%20of%20people%20trapped%20in%20an%20underground%20bunker%20with%20dim%20emergency%20lights%2C%20tense%20atmosphere%2C%20survival%20horror%20genre%2C%20stark%20shadows%2C%20claustrophobic%20setting%2C%20clean%20dark%20background%2C%20professional%20manhwa%20cover&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    category: '悬疑',
    categorySlug: 'thriller',
    status: '连载中',
    description: '一场突如其来的灾难让整个城市陷入地下。幸存者们被困在黑暗的废墟中，没有阳光，没有食物，没有希望。在这个深渊般的环境中，人性中最黑暗和最光辉的一面都将被激发出来。谁能活着爬出这片深渊？',
    shortDescription: '城市陷入地下后幸存者的生存挣扎，在黑暗中考验人性的极限。',
    updateTime: '2026-08-03',
    views: 720000,
    rating: 9.0,
    isHot: false,
    isNew: true,
    tags: ['末世', '悬疑', '人性', '生存'],
    chapters: [
      { id: 'ch-8-1', number: 1, title: '坠落', updateDate: '2025-12-10', views: 55000 },
    ],
  },
  {
    id: 'comic-9',
    title: '神之塔',
    author: 'SIU',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20fantasy%20illustration%20of%20a%20young%20boy%20climbing%20a%20massive%20mysterious%20tower%20that%20reaches%20into%20the%20clouds%2C%20epic%20scale%2C%20adventure%20fantasy%20genre%2C%20bright%20sky%20and%20clouds%20around%20the%20tower%2C%20clean%20heroic%20composition%2C%20professional%20manhwa%20cover&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    category: '奇幻',
    categorySlug: 'fantasy',
    status: '连载中',
    description: '有一座塔，传说只要爬到塔顶就能获得任何想要的东西。第二十五夜为了追寻唯一的朋友蕾哈尔而进入神之塔，在这里他将经历无数试炼，结识各路奇人异士，逐渐揭开塔与世界之间的秘密。',
    shortDescription: '少年夜为追寻朋友进入神之塔，在无尽试炼中揭开世界的秘密。',
    updateTime: '2026-08-04',
    views: 4200000,
    rating: 9.7,
    isHot: true,
    isNew: false,
    tags: ['奇幻', '冒险', '热血', '战斗'],
    chapters: [
      { id: 'ch-9-1', number: 1, title: '塔的入口', updateDate: '2019-05-10', views: 300000 },
    ],
  },
  {
    id: 'comic-10',
    title: '甜蜜的陷阱',
    author: '柳娜娜',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20sweet%20romance%20illustration%20of%20a%20young%20couple%20sharing%20a%20dessert%20at%20a%20cozy%20bakery%20cafe%2C%20warm%20golden%20hour%20lighting%20through%20window%2C%20soft%20pastel%20color%20scheme%2C%20romantic%20atmosphere%20with%20floating%20heart%20motifs%2C%20clean%20warm%20cream%20background%2C%20professional%20manhwa%20cover&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    category: '恋爱',
    categorySlug: 'romance',
    status: '连载中',
    description: '甜品师苏甜甜的梦想是开一家属于自己的甜品店。当她的店铺意外被连锁甜品帝国收购后，冷酷的CEO陆景琛走进了她的生活。一个是热爱甜品的温暖女孩，一个是对甜品过敏的商业精英，这对看似最不般配的组合，却在甜品香气中谱写了一段甜蜜恋曲。',
    shortDescription: '甜品师女孩与对甜品过敏的CEO，在甜品香气中展开的甜蜜浪漫故事。',
    updateTime: '2026-08-04',
    views: 890000,
    rating: 9.2,
    isHot: false,
    isNew: true,
    tags: ['现代', '美食', '恋爱', '治愈'],
    chapters: [
      { id: 'ch-10-1', number: 1, title: '梦想的甜品店', updateDate: '2026-01-05', views: 45000 },
    ],
  },
  {
    id: 'comic-11',
    title: '剑尊归来',
    author: 'LEE Jin-Hwan / Redice Studio',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20action%20illustration%20of%20a%20powerful%20swordsman%20in%20traditional%20martial%20arts%20robe%20holding%20a%20glowing%20sword%2C%20standing%20on%20a%20mountain%20peak%20with%20dramatic%20sunset%20sky%2C%20epic%20wuxia%20style%2C%20flowing%20fabric%20and%20energy%20effects%2C%20clean%20warm%20gradient%20background%2C%20professional%20manhwa%20cover&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    category: '动作',
    categorySlug: 'action',
    status: '连载中',
    description: '天下第一剑尊陈武在击败所有敌人后，却发现自己回到了少年时期。带着前世百年的武学记忆，他决定重新踏上武道之路。这一次，他不仅要变得更强大，还要改变那些前世令他遗憾终生的命运。',
    shortDescription: '天下第一剑尊重返少年时代，带着前世记忆重新踏上无敌武道之路。',
    updateTime: '2026-08-03',
    views: 1950000,
    rating: 9.5,
    isHot: true,
    isNew: false,
    tags: ['重生', '武侠', '战斗', '爽文'],
    chapters: [
      { id: 'ch-11-1', number: 1, title: '重生的剑尊', updateDate: '2024-03-15', views: 180000 },
    ],
  },
  {
    id: 'comic-12',
    title: '女神降临',
    author: '猫咪',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20beauty%20illustration%20of%20a%20girl%20transforming%20from%20plain%20to%20glamorous%20through%20makeup%2C%20split%20composition%20showing%20before%20and%20after%2C%20school%20setting%2C%20teen%20romance%20genre%2C%20bright%20cheerful%20lighting%2C%20clean%20pastel%20pink%20background%2C%20professional%20manhwa%20cover&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    category: '搞笑',
    categorySlug: 'comedy',
    status: '已完结',
    description: '林周京因为长相普通而遭受校园霸凌，转学后她通过化妆技巧彻底改变了自己的外貌，成为了新学校的"女神"。然而她最大的恐惧就是被人发现自己的素颜。当校园里最帅的两个男生同时对她产生兴趣时，她的双重身份变得越来越难以维持。',
    shortDescription: '通过化妆变身为校园女神的普通女孩，在双重身份中周旋的爆笑故事。',
    updateTime: '2026-08-01',
    views: 3100000,
    rating: 9.3,
    isHot: true,
    isNew: false,
    tags: ['校园', '恋爱', '搞笑', '变身'],
    chapters: [
      { id: 'ch-12-1', number: 1, title: '新学校的开始', updateDate: '2020-12-01', views: 250000 },
    ],
  },
];

export const faqs = [
  {
    question: '韩国漫画网的漫画是免费的吗？',
    answer: '是的，韩国漫画网上的所有漫画资源均为免费观看，无需付费订阅。我们致力于为广大韩漫爱好者提供最优质的免费韩漫在线阅读体验，每日更新热门漫画，让您畅享下拉式阅读的乐趣。',
  },
  {
    question: '如何使用下拉式阅读功能？',
    answer: '下拉式阅读是韩国漫画的特色阅读方式，您只需打开任意一部漫画，页面会自动采用垂直滚动布局，无需翻页。直接用鼠标滚轮或手指向下滑动即可连续阅读，提供沉浸式的漫画阅读体验。',
  },
  {
    question: '漫画更新频率是怎样的？',
    answer: '韩国漫画网保持日更不断更的更新节奏。热门连载漫画通常每周更新1-2话，我们会在第一时间同步更新。您可以通过收藏功能追踪自己喜欢的漫画，更新时会收到提醒。',
  },
  {
    question: '如何在手机上观看韩漫？',
    answer: '韩国漫画网全面支持移动端浏览，您只需在手机浏览器中打开我们的网站，即可享受适配手机屏幕的下拉式阅读体验。无需下载任何APP，随时随地畅享韩漫阅读。',
  },
  {
    question: '网站的漫画资源来自哪里？',
    answer: '韩国漫画网聚合了韩国各大漫画平台的优质资源，为读者提供一站式的韩国漫画网站大全入口。我们精选优质的韩漫作品，覆盖恋爱、动作、奇幻、悬疑等多种分类，满足不同读者的口味需求。',
  },
  {
    question: '如何搜索我想看的漫画？',
    answer: '您可以使用网站顶部的搜索功能，输入漫画名称或作者名称即可快速找到目标漫画。此外，您也可以通过分类浏览功能，按照恋爱、动作、奇幻等不同类别浏览感兴趣的作品。',
  },
];

export const hotKeywords = [
  '再婚皇后', '我独自升级', '全知读者视角', '神之塔', '社内相亲',
  '女神降临', '剑尊归来', '某天成为公主', '免费韩漫', '韩漫在线看',
];

export const siteInfo = {
  name: '韩国漫画网',
  description: '韩国漫画网提供韩国漫画网站大全资源，海量免费韩漫在线看，支持下拉式阅读，实时追更热门漫画，日更不断更。',
  founded: '2020年',
  email: 'contact@koreancomic.cn',
  features: [
    {
      title: '海量免费资源',
      description: '汇集韩国漫画网站大全，上千部热门韩漫免费观看，覆盖恋爱、动作、奇幻、悬疑、搞笑等全部分类。',
      icon: 'ri-book-open-line',
    },
    {
      title: '下拉式阅读',
      description: '专为移动端优化的下拉式漫画阅读体验，无需翻页，流畅丝滑的纵向滚动，沉浸式享受韩漫。',
      icon: 'ri-file-list-line',
    },
    {
      title: '实时追更',
      description: '日更不断更，第一时间同步更新热门漫画最新章节，让您不再错过任何精彩剧情。',
      icon: 'ri-timer-flash-line',
    },
    {
      title: '多端适配',
      description: '全面支持PC端和手机端浏览，自适应屏幕尺寸，随时随地畅享韩漫在线阅读体验。',
      icon: 'ri-device-line',
    },
  ],
};